var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7178 7.9873V12.6383L15.3738 14.8673",
    stroke: "#7336A5",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.763 17.9248C17.48 19.3878 15.735 20.4348 13.75 20.8268",
    stroke: "#7336A5",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23633 6.07583C6.51933 4.61283 8.26433 3.56583 10.2493 3.17383",
    stroke: "#7336A5",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48469 14.8955C3.17469 13.9855 2.99969 13.0135 2.99969 11.9995C2.99969 10.9855 3.17469 10.0135 3.48469 9.10352",
    stroke: "#7336A5",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5153 14.8955C20.8253 13.9855 21.0003 13.0135 21.0003 11.9995C21.0003 10.9855 20.8253 10.0135 20.5153 9.10352",
    stroke: "#7336A5",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23633 17.9248C6.51933 19.3878 8.26433 20.4348 10.2493 20.8268",
    stroke: "#7336A5",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 3.17383C15.735 3.56483 17.479 4.61183 18.763 6.07583",
    stroke: "#7336A5",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/Timeline.fe7cffd039f34a25b1a1448f3f297502.svg";
export { ForwardRef as ReactComponent };